import { Button, JoonUIColor, Typography, UserRole } from "@joonapp/web-shared"
import { toast } from "react-hot-toast"
import { useTranslation } from "react-i18next"

import { useChildPasscodeModalStore } from "./useChildPasscodeModalStore"
import PasscodeInput from "../../../../components/passcodeInput/PasscodeInput"
import useMultiInputFocus from "../../../../hooks/useMultiInputFocus"
import { useEditPasscodeMutation } from "../../../../networking/rewards/mutations"
import useSelectedFamilyMember from "../../hooks/useSelectedFamilyMember"

const ConfirmSetChildPasscode = () => {
  const {
    passcode,
    confirmPasscode,
    setConfirmPasscode,
    onClose,
    showError,
    setShowError,
  } = useChildPasscodeModalStore()
  const { selectedProfile } = useSelectedFamilyMember()
  const editPasscodeMutation = useEditPasscodeMutation()
  const { t } = useTranslation()
  const {
    ref: passcodeInputRef,
    focusFirstInput,
    clearInputs,
  } = useMultiInputFocus({})

  const isChangingPasscode =
    selectedProfile?.role === UserRole.CHILD &&
    selectedProfile?.user.account_passcode !== null

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!selectedProfile) return
    if (passcode !== confirmPasscode) {
      setConfirmPasscode("")
      focusFirstInput()
      clearInputs()
      setShowError(true)
      return
    }
    setShowError(false)
    editPasscodeMutation.mutate({
      userId: selectedProfile.user.id,
      accountPasscode: confirmPasscode,
    })
    toast.success(
      isChangingPasscode ? t("CCP_TOAST_CHANGED") : t("CCP_TOAST_SET")
    )
    onClose()
  }

  return (
    <form onSubmit={onSubmit}>
      <div className="flex flex-col gap-4">
        <Typography variant="bodyBold">{t("CCP_CONFIRM_TITLE")}</Typography>

        <PasscodeInput
          value={confirmPasscode}
          setValue={setConfirmPasscode}
          ref={passcodeInputRef}
        />

        <Button
          text={t("PPC_CONFIRM")}
          type="submit"
          fullWidth
          disabled={confirmPasscode.length !== 4}
        />
        {showError && (
          <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
            {t("PPC_ERR_NO_MATCH")}
          </Typography>
        )}
      </div>
    </form>
  )
}

export default ConfirmSetChildPasscode
